import getLocalString from "constants/Localization";
import { useGetReportEquipmentCostDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportEquipmentCostDetails = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportEquipmentCostDetailsMutation();
  const [getReportEquipmentCostDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportEquipmentCostDetails",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportEquipmentCostDetails, { ...context, data }] as const;
};

export default useGetReportEquipmentCostDetails;
